import URL from 'url';
import { createAction, handleActions } from 'redux-actions';
import { getUrl } from './Settings';
import { getPaginatedHref, link } from '../app/helpers';
import { createSelector } from 'reselect';

const actionsPrefix = 'app-job-search/jobs-list';

export const INITIAL_STATE = {
  loaded: false,
  baseQuery: null,
  page: null,
  perPage: null,
  totalpages: null,
  totalJobs: null,
  jobs: [],
  mzData: null,
  loading: false,
  error: false,
  errorMsg: null,
  leaderboard: null,
  leaderboardMobile: null,
  takeover: null
};

// setters (actions)
export const setJobsData = createAction(`${actionsPrefix}/SET_JOBS`);
export const setLoadingJobsData = createAction(`${actionsPrefix}/LOADING_JOBS`);
export const setBaseQuery = createAction(`${actionsPrefix}/SET_BASE_QUERY`);
export const setPage = createAction(`${actionsPrefix}/SET_PAGE`);
export const setMzData = createAction(`${actionsPrefix}/SET_MZ_DATA`);
export const setFetchJobsFailed = createAction(`${actionsPrefix}/SET_FETCH_JOBS_FAILED`);
export const fetchJobsClient = createAction(`${actionsPrefix}/FETCH_JOBS_CLIENT`);

// reducers state => newState
export default handleActions({
  [setJobsData]: (state, { payload: { jobs: { items, metadata }, mzData, errorMsg = '', leaderboard, leaderboardMobile, takeover, doubleMpu, baseUrl, siteUrlPrefix } }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: false,
    jobs: items.map(job => {
      const { jobPageCanonicalUrl } = job;
      const { protocol, hostname } = URL.parse(jobPageCanonicalUrl);
      // to ensure job canonical url is correctly "localised"
      // we need to be sure the baseUrl matches (i.e. on dev if I'm on tes-local and I get jobs from live)
      const finalUrl = link({ baseUrl, siteUrlPrefix }, jobPageCanonicalUrl.replace(`${protocol}//${hostname}`, baseUrl));
      return {
        ...job,
        jobPageCanonicalUrl: finalUrl
      };
    }),
    totalJobs: metadata.count,
    page: metadata.pagination.currentpage,
    perPage: metadata.pagination.numberperpage,
    totalpages: metadata.pagination.totalpages,
    mzData,
    errorMsg,
    leaderboard,
    leaderboardMobile,
    takeover,
    doubleMpu
  }),
  [setLoadingJobsData]: (state) => ({...state, loading: true, loaded: false }),
  [setBaseQuery]: (state, { payload: baseQuery }) => ({ ...state, baseQuery }),
  [setPage]: (state, { payload: page }) => ({ ...state, page }),
  [setMzData]: (state, { payload: mzData }) => ({ ...state, mzData }),
  [setFetchJobsFailed]: (state) => ({ ...state, error: true, loading: false })
}, INITIAL_STATE);

// getters (selectors)
export const get = state => state.jobsList;
export const getJobs = createSelector(get, ({ jobs }) => jobs);
export const getBaseQuery = createSelector(get, ({ baseQuery }) => baseQuery);
export const getPage = createSelector(get, ({ page }) => page);
export const getTotalJobs = createSelector(get, ({ totalJobs }) => totalJobs);
export const getMzData = createSelector(get, ({ mzData }) => mzData);
export const getLoading = createSelector(get, ({ loading }) => loading);
export const getError = createSelector(get, ({ error }) => error);
export const getDoubleMpu = createSelector(get, ({ doubleMpu }) => doubleMpu);
export const getLeaderboard = createSelector(get, ({ leaderboard }) => leaderboard);
export const getLeaderboardMobile = createSelector(get, ({ leaderboardMobile }) => leaderboardMobile);
export const getTakeover = createSelector(get, ({ takeover }) => takeover);

export const getPrevPagePath = (state) => {
  const page = getPage(state);
  if (page === 1) return null;
  return getPaginatedHref(getUrl(state), page - 1);
};

export const getNextPagePath = (state) => {
  const page = getPage(state);
  if (getTotalJobs(state) <= page * 20) return null;
  return getPaginatedHref(getUrl(state), page + 1);
};
